module.exports = __webpack_public_path__ + "img/m_supply.9793f7df.jpg";